export const getNumberInputValue = inputValue =>
  inputValue === undefined ? null : Number(inputValue);
